var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgMoreHorizontal = function SvgMoreHorizontal(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.66602 8.16634C3.66602 8.62658 4.03911 8.99967 4.49935 8.99967C4.95959 8.99967 5.33268 8.62658 5.33268 8.16634C5.33268 7.7061 4.95959 7.33301 4.49935 7.33301C4.03911 7.33301 3.66602 7.7061 3.66602 8.16634Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.83268 8.99967C7.37245 8.99967 6.99935 8.62658 6.99935 8.16634C6.99935 7.7061 7.37245 7.33301 7.83268 7.33301C8.29292 7.33301 8.66602 7.7061 8.66602 8.16634C8.66602 8.62658 8.29292 8.99967 7.83268 8.99967Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.166 8.99967C10.7058 8.99967 10.3327 8.62658 10.3327 8.16634C10.3327 7.7061 10.7058 7.33301 11.166 7.33301C11.6263 7.33301 11.9993 7.7061 11.9993 8.16634C11.9993 8.62658 11.6263 8.99967 11.166 8.99967Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMoreHorizontal);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "more-horizontal.c0b0b9c27a3a20597fd933b4751f3049.svg";